import { createSlice } from '@reduxjs/toolkit';

import { resetOnLogOutMatcher } from 'src/services/auth';
import { videoApi } from './api';
import { VideoState } from './types';

const initialState = {
  deletedVideos: {},
  unfavoritedVideos: {},
} as VideoState;

export const videoSlice = createSlice({
  extraReducers: (builder) =>
    builder
      .addMatcher(
        videoApi.endpoints.deleteVideo.matchFulfilled,
        (state, action) => ({
          ...state,
          deletedVideos: {
            ...state.deletedVideos,
            [action.meta.arg.originalArgs.id]: true,
          },
        }),
      )
      .addMatcher(
        videoApi.endpoints.toggleVideoFavorite.matchFulfilled,
        (state, action) => ({
          ...state,
          unfavoritedVideos: {
            ...state.unfavoritedVideos,
            [action.meta.arg.originalArgs.id]: !action.payload.isFavourite,
          },
        }),
      )
      .addMatcher(...resetOnLogOutMatcher(initialState)),
  initialState,
  name: 'video',
  reducers: {},
});
